export default function minZero(n: number): number {
  return n < 0 ? 0 : n;
}
